import { baseQuery } from '../baseQuery';

type DeleteTechnicianSkillSetPayload = {
  techId: number;
  technicianSkillSetId: number;
};

export const deleteTechnicianSkillSet = async (payload: DeleteTechnicianSkillSetPayload) => {
  const { techId, technicianSkillSetId } = payload;
  const { data } = await baseQuery(`technicians/${techId}/skill-sets/${technicianSkillSetId}`, {
    type: 'DELETE',
  });

  return data;
};
